<template>
      
    <a-layout class="layout">
         <!-- 左侧开始 -->
        <a-layout-sider v-model:collapsed="collapsed" :trigger="null" collapsible>
        <div class="logoIcon" v-if="collapsed">
          <svg  t="1742017625254" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2649" width="40" height="40"><path d="M906.816 580.192a27.264 27.264 0 0 0-38.56-6.4l-49.056 36.16a378.368 378.368 0 0 0 12.992-98.016 360.16 360.16 0 1 0-360.16 369.28 352.48 352.48 0 0 0 178.432-48.704 26.88 26.88 0 0 0 8.48-3.2 361.12 361.12 0 0 0 44.16-31.808 28.8 28.8 0 0 0 3.808-39.904 27.168 27.168 0 0 0-38.88-3.904 305.888 305.888 0 0 1-34.592 24.928 23.552 23.552 0 0 0-5.504 1.984 298.432 298.432 0 0 1-155.872 43.904 312.672 312.672 0 1 1 304.736-312.544 320 320 0 0 1-20.704 113.504l-39.072-96.256a27.456 27.456 0 0 0-36.16-15.264 28.576 28.576 0 0 0-14.88 37.056l62.144 153.056a30.112 30.112 0 0 0 2.528 4.384c0.256 0.416 0.288 0.832 0.544 1.216s0.256 0.192 0.352 0.32a27.616 27.616 0 0 0 8.832 7.68 14.88 14.88 0 0 0 1.792 0.96 26.624 26.624 0 0 0 9.184 2.72h1.6c0.544 0 0.48 0.16 0.704 0.16a16.416 16.416 0 0 0 1.696-0.288 28.192 28.192 0 0 0 6.048-0.928l1.248-0.448a27.744 27.744 0 0 0 6.4-3.2c0.288-0.192 0.576-0.256 0.832-0.448l130.624-96.64a28.8 28.8 0 0 0 6.4-39.488z m-311.456-183.936a27.328 27.328 0 0 0 0.672-39.808 30.304 30.304 0 0 0-41.6-0.672l-73.216 67.84-73.28-67.84a30.304 30.304 0 0 0-41.6 0.672 27.296 27.296 0 0 0 0.672 39.808l82.464 76.352v16.448h-58.688a28.192 28.192 0 1 0 0 56.32h58.784v28.128h-58.784a28.16 28.16 0 1 0 0 56.288h58.784v59.168a29.408 29.408 0 0 0 58.784 0v-59.168h58.784a28.16 28.16 0 1 0 0-56.288h-58.816v-28.128h58.784a28.192 28.192 0 1 0 0-56.32h-58.784v-12.224z" p-id="2650" fill="#e6e6e6"></path></svg>
        </div>
        <div v-else class="logo" >职工体育服务平台 </div>
       
        <a-menu v-model:selectedKeys="current" theme="dark" mode="inline">
        
          <!-- <a-sub-menu  v-for="(item1) in menus" :key="item1.path">
          <template #title>
            <span>
              <component :is="getIcon(item1.icon)" />
              <span>{{item1.title}}</span>
            </span>
          </template>
          <a-menu-item  v-for="(item2) in item1.childre" :key="item2.path" @click="$router.push(item2.path)">{{item2.title}}</a-menu-item>
         
        </a-sub-menu> -->

        <a-menu-item key="reservation" @click="$router.push('reservation')">
          <user-outlined />
          <span>预约管理</span>
        </a-menu-item>

        <a-menu-item key="course"  @click="$router.push('course')">
          <MailOutlined />
          <span>课程管理</span>
        </a-menu-item>
        <a-menu-item key="teacher"  @click="$router.push('teacher')">
          <upload-outlined />
          <span>师资管理</span>
        </a-menu-item>
        <a-menu-item key="statistics"  @click="$router.push('statistics')">
          <upload-outlined />
          <span>统计管理</span>
        </a-menu-item>
      </a-menu>

        </a-layout-sider>
            <!-- 左侧结束 -->


    <a-layout>
        <!-- 顶部开始 -->
      <a-layout-header class="header" >
        <menu-unfold-outlined
          v-if="collapsed"
          class="trigger"
          @click="() => (collapsed = !collapsed)"
        />
        <menu-fold-outlined v-else class="trigger" @click="() => (collapsed = !collapsed)" />
      
      <a-menu v-model:selectedKeys="current" mode="horizontal" theme="dark">
          
          <a-sub-menu key="sub1">
            <template #icon>
              <SettingOutlined />
            </template>
            <template #title>{{name}}</template>
            
            <a-menu-item key="setting:3" @click="exit">退出登录</a-menu-item>
          </a-sub-menu>
      </a-menu>
        
      </a-layout-header>


      <!-- 顶部结束 -->

      <!-- 右侧内容开始 -->
      <a-layout-content
        :style="{ margin: '10px', padding: '15px', background: '#fff' }" >
      
        <router-view></router-view>

        <!-- 修改密码的弹窗开始 -->
        <a-modal
              v-model:visible="visible"
              title="修改密码"
              ok-text="提交"
              cancel-text="取消"
              @ok="submitUser"
              @cancel="afterClose"
            >
          <a-form ref="updateFormRef"
            :model="updateFormState"
            name="basic"
            :label-col="{ span: 4 }"
            :wrapper-col="{ span: 19 }"
            layout="vertical"
          >
            <a-form-item
              label="原始密码"
              name="oldpasswd"
              :rules="[{ required: true, message: '请输原始密码!' }]"
            >
              <a-input v-model:value="updateFormState.oldpasswd" />
            </a-form-item>

            <a-form-item
              label="新密码"
              name="newpassword"
              :rules="[{ required: true, message: '请输入新密码!' }]"
            >
              <a-input-password v-model:value="updateFormState.newpassword" />
            </a-form-item>

            <a-form-item
              label="重复密码"
              name="newpassword2"
              :rules="[{ required: true, message: '请重复输入新密码!' }]"
            >
              <a-input-password v-model:value="updateFormState.newpassword2" />
            </a-form-item>
           
          </a-form>
        </a-modal>
        <!-- 修改密码的弹窗结束 -->

      </a-layout-content>
      <!-- 右侧内容结束 -->

      
      <a-layout-footer style="text-align: center">
        职工体育服务平台 ©2025
      </a-layout-footer>

    </a-layout>
  </a-layout>
  </template>
  <script setup>
  import { useRouter } from 'vue-router';
  import {message} from 'ant-design-vue'
  import { onMounted,reactive } from 'vue';
  import { $submitUser } from '../../api/systemUser.js';
  

  const visible = ref(false);
  const updateFormRef = ref();
  let $router=useRouter();

  //导入图标
  import {MailOutlined, SettingOutlined,UserOutlined,UploadOutlined,MenuUnfoldOutlined,MenuFoldOutlined} from '@ant-design/icons-vue';
  import {ref } from 'vue';
  //顶部菜单默认选中，这里取消，不选中
  const current = ref(['']);//ref(['mail']);
  
  const menus=JSON.parse(localStorage.getItem("menus"));
    //判断用户是否登陆,这种方法不是很好，应该把这个逻辑放到路由那里进行验证
    let name="你好";
  onMounted(() => {
    let info=localStorage.getItem("userInfo");
    if(info==null || info=='null'){
      $router.push("/login")
    }else{
      name=JSON.parse(info).name;
    }
  });

const updateFormState = reactive({
  newpassword: '',
  newpassword2: '',
  oldpasswd: '',
});
const submitUser =async () => {
  console.log(updateFormState);
  updateFormRef.value.validateFields().then(() => {
        console.log("校验通过")
        //点击提交
        $submitUser(updateFormState).then((res)=>{
          if(res.code=='200'){
            visible.value = false;
            message.success(res.msg)
            updateFormRef.value.resetFields();
          }else{
            message.error(res.msg)
          }
        });
  }).catch(() => {
      console.log("校验未通过")
  })
  
}
const afterClose =()=>{
  visible.value = false;
  updateFormRef.value.resetFields();
}



  //当页面加载时开始处理的逻辑都写在onMounted
  onMounted(()=>{
    // menus.forEach(m1 => {
    //   m1.childre.forEach(m2 =>{
        
    //     $router.addRoute("layout",{
    //       path:"/"+m2.path,
    //       name:m2.title,
    //       component:()=>import("@/views/"+m1.path+"/"+m2.path+".vue")
    //     })
    //   })
    // });
    // $router.push("/main")
  })

// const showModel = () => {
//   visible.value = true;
// }

  let exit=() =>{
    localStorage.clear();  
    localStorage.clear();
    $router.push("/login")
  }
  const getIcon = (iconName) => {
  switch (iconName) {
    case 'UserOutlined':
      return UserOutlined;
    case 'SettingOutlined':
      return SettingOutlined;

    case 'MenuFoldOutlined':
      return MenuFoldOutlined;
    case 'UploadOutlined':
      return UploadOutlined;
   
    default:
      return MailOutlined; // 如果没有匹配到，返回null或其他默认图标
  }
};

//左侧菜单展开的选项
//  let openKeys =ref(['main','home'])
  //左侧菜单选中的key,默认不选中
  //const selectedKeys = ref(['main','home']);
  
  //是否折叠菜单栏
  const collapsed = ref(false);
  </script>


  <style scoped lang="scss">
  .logoIcon{
    display: flex;
    justify-content: center; /* 水平居中 */
    align-items: center;    /* 垂直居中 */
    margin: 14px;
  }
  .layout{
      width: 100vw;
      height: 100vh;
      .header{
        background: durk; padding: 0;
        display: flex;
        justify-content: space-between;
      }
      
      // logo的样式
      .logo{
          height: 32px;
          background: rgba(255, 255, 255, 0.3);
          margin: 16px;

          color:#ffffffa6;
          text-align: center;
          line-height: 32px;
      }
      .trigger {
        font-size: 18px;
        line-height: 64px;
        padding: 0 24px;
        cursor: pointer;
        transition: color 0.3s;
        color: #ffffffa6;
        &:hover{
          color: #1890ff;
        }
      }
  }



 


  </style>